








































































































import { Component, Vue } from 'vue-property-decorator'
import Moment from 'moment'
import ApiLegacy from '@finx/web-repository/src/apis/Legacy/Legacy'

@Component({
  props: {
    fontePagadora: {
      type: Object,
      default: {},
    },
    periodo: {
      type: String,
      default: 'Ultimos 6 meses',
    },
    status: {
      type: String,
    },
    toggleDivergencias: {
      type: Boolean,
    },
  },
})

export default class ComponentRelatorioRecebimentoFontePagadora extends Vue {
  data() {
    return {
      relatorioData: {},
      relatorioPeriod: {
        start: null,
        end: null,
      },
      today: null,
      periodType: null,
    }
  }

  mounted() {
    // @ts-ignore
    this.today = Moment(new Date()).format('DD/MM/YYYY')
    // @ts-ignore
    this.relatorioPeriod = {
      start: Moment().subtract(6, 'months').startOf('month').format('YYYY-MM-DD'),
      end: Moment(new Date()).endOf('month').format('YYYY-MM-DD'),
    }

    // @ts-ignore
    if (this.periodo === 'Ultimos 6 meses') {
      // @ts-ignore
      this.periodType = '6meses'
    } else {
      // @ts-ignore
      this.periodType = 'mes'
    }

    // this.getPdfData()
  }

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.$user.profile.email)
  }

  async getPdfData() {
    // @ts-ignore
    const relatorioData = await ApiLegacy.Reports.getPdfData(this.relatorioPeriod.start, this.relatorioPeriod.end, this.fontePagadora.idFontePagadora)

    // @ts-ignore
    this.relatorioData = relatorioData.data.data
  }

  getPeriodoMes(date) {
    let month = Moment().month(date.split('/')[0]).format('MMMM')
    month = Moment().month(month).format('MM')

    const year = date.split('/')[1]

    const full = `${year}-${month}`

    return full
  }

  toggleStatusDivergencia(status) {
    let hide

    switch (status) {
      case 'PagoAtrasado':
        hide = true
        break
      case 'PagoAdiantado':
        hide = true
        break
      case 'PagoNoPrazo':
        hide = true
        break
      default:
        hide = undefined
    }

    // @ts-ignore
    if (this.toggleDivergencias && hide) {
      return false
    }

    return true
  }
}
